import * as React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectTrigger, SelectValue } from '@/components/ui/select';

// Scope item option: the activity name lives in ItemText (shown in the list AND cloned
// into the trigger as a single clean line); the optional detail is a sibling shown ONLY
// in the dropdown list, so it never overflows/overlaps the trigger + label.
const ScopeItem = React.forwardRef(({ activity, detail, className, ...props }, ref) => (
  <SelectPrimitive.Item
    ref={ref}
    className={cn(
      'relative flex w-full cursor-default select-none flex-col rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      className,
    )}
    {...props}
  >
    <span className="absolute right-2 top-2 flex h-3.5 w-3.5 items-center justify-center">
      <SelectPrimitive.ItemIndicator><Check className="h-4 w-4" /></SelectPrimitive.ItemIndicator>
    </span>
    <SelectPrimitive.ItemText className="text-sm">{activity}</SelectPrimitive.ItemText>
    {detail && (
      <span className="text-xs text-muted-foreground max-w-[22rem] whitespace-normal leading-snug mt-0.5">{detail}</span>
    )}
  </SelectPrimitive.Item>
));
ScopeItem.displayName = 'ScopeItem';

export function ScopeLinkSelect({ items = [], value, onChange, testid }) {
  return (
    <div>
      <Label className="text-xs text-muted-foreground">Link to scope item</Label>
      <Select value={value || '__none'} onValueChange={v => onChange(v === '__none' ? '' : v)}>
        <SelectTrigger className="bg-background border-border mt-1" data-testid={testid}>
          <SelectValue placeholder="None" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border">
          <ScopeItem value="__none" activity="None" />
          {items.map(it => (
            <ScopeItem key={it.item_id} value={it.item_id} activity={it.activity} detail={it.scope_detail || it.description} />
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
